import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Actions, Select, ofActionDispatched } from '@ngxs/store';
import { CartOverlayService } from '@x/ecommerce-shop/app/core/order/services/cart-overlay.service';
import { OrderItemAddedToCartAlert } from '@x/ecommerce-shop/app/core/order/state/shop-order.actions';
import {
  OrderStateModel,
  ShopOrderState,
} from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { ShopOverlayService } from '@x/ecommerce-shop/app/core/shop-overlay/shop-overlay.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'x-order-bag-button',
  templateUrl: './order-bag-button.component.html',
  styleUrls: ['./order-bag-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-order-bag-button' },
})
export class OrderBagButtonComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();

  @Select(ShopOrderState) state$: Observable<OrderStateModel>;
  @Select(ShopOrderState.orderItemCount) orderItemCount$: Observable<string>;

  constructor(
    private actions$: Actions,
    private el: ElementRef,
    private shopOverlayService: ShopOverlayService,
    public miniCartService: CartOverlayService,
  ) {}

  overlayKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.miniCartService.closeCart();
    }
  }

  handleOverlayOutsideClick() {
    if (!this.miniCartService.hasActiveOverlays()) {
      this.miniCartService.closeCart();
    }
  }

  ngOnInit(): void {
    this._subscription.add(
      this.actions$
        .pipe(ofActionDispatched(OrderItemAddedToCartAlert))
        .subscribe(({ orderItem, association }) => {
          this.shopOverlayService.showAddToBagNotification(orderItem, this.el, 2000, association);
        }),
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
